const icon = `
<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
<style type="text/css">
	.st0{fill:{{strokeColor}};}
</style>
<path class="st0" d="M4.86,11.6c0.63-0.14,1.77-0.25,2.88-0.25c1.46,0,2.36,0.2,3.1,0.77c0.68,0.45,1.13,1.24,1.13,2.27
	c0,1.12-0.63,2.14-1.8,2.63v0.04c1.14,0.32,2.19,1.33,2.19,3.01c0,1.08-0.42,1.93-1.05,2.5c-0.77,0.76-2.04,1.13-4.02,1.13
	c-1.09,0-1.93-0.09-2.43-0.16V11.6z M6.82,16.39h1.01c1.37,0,2.14-0.72,2.14-1.75c0-1.13-0.77-1.66-2.03-1.66
	c-0.58,0-0.92,0.04-1.13,0.09V16.39z M6.82,21.97c0.26,0.04,0.6,0.05,1.05,0.05c1.27,0,2.4-0.54,2.4-2.03c0-1.4-1.09-1.98-2.46-1.98
	H6.82V21.97z"/>
<path class="st0" d="M21.89,23.22c-0.47,0.27-1.5,0.54-2.8,0.54c-3.44,0-5.53-2.41-5.53-6.1c0-4,2.48-6.41,5.79-6.41
	c1.3,0,2.24,0.31,2.64,0.54l-0.43,1.76c-0.51-0.25-1.22-0.47-2.12-0.47c-2.2,0-3.8,1.55-3.8,4.47c0,2.66,1.4,4.38,3.78,4.38
	c0.8,0,1.64-0.18,2.16-0.45L21.89,23.22z"/>
<path class="st0" d="M23.53,21.16c0.64,0.41,1.61,0.77,2.62,0.77c1.27,0,1.98-0.67,1.98-1.66c0-0.92-0.55-1.46-1.93-2.02
	c-1.79-0.72-2.93-1.78-2.93-3.53c0-1.98,1.48-3.49,3.83-3.49c1.17,0,2.04,0.29,2.61,0.61l-0.48,1.78c-0.39-0.23-1.14-0.58-2.16-0.58
	c-1.25,0-1.8,0.76-1.8,1.46c0,0.94,0.63,1.37,2.07,2c1.88,0.79,2.8,1.85,2.8,3.6c0,1.94-1.32,3.64-4.12,3.64
	c-1.14,0-2.33-0.36-2.93-0.76L23.53,21.16z"/>
</svg>
`

export const BCS = {
  name: 'BCS',
  description: 'The object groups composing the BCS system',
  icon,
  templates: []
}
